import { makeObservable, observable, runInAction, action, makeAutoObservable } from 'mobx';
import { ExpenseVatServices } from '../services/expenseVatServices';
import i18n from 'i18next';
import { toast } from "react-toastify";
import { makePersistable, stopPersisting } from 'mobx-persist-store';


export default class ExpenseVatStore {    

    
  rootStore;
  expenseVats = [];
    expenseVat = {};
    config = {
        sort: [],
        filter: [],
        size: {}
    };

  constructor(rootStore) {
      this.rootStore = rootStore;

      makeObservable(this, {
          config: observable,
          setConfig: action,

          getAllWithOptions:action,
          expenseVats: observable,
          expenseVat: observable,
          
          reset: action,
          save: action,
          remove: action,
          duplicate:action
      });

      makePersistable(this, { name: 'expenseVatStore', properties: ['config'], storage: window.localStorage });

    }       

    remove = async (id) => {
        try {
            const data = await ExpenseVatServices.delete(id);
            runInAction(() => { toast.success(`${i18n.t("wasDeleted", { entity: i18n.t("expenseVat") })}`);});
        } catch (error) {
            runInAction(() => {/*toast.error(i18n.t("errorOcurred"));*/});
        }
    }

    duplicate = async (id) => {
        try {
            const data = await ExpenseVatServices.duplicate(id);
            runInAction(() => { toast.success(`${i18n.t("wasDuplicated", { entity: i18n.t("expenseVat") })}`); });
        } catch (error) {
            runInAction(() => {/*toast.error(i18n.t("errorOcurred"));*/ });
        }
    }

    save = async (entity, onSuccess) => {
        if (entity.id) {
            try {
                const data = await ExpenseVatServices.update(entity.id, entity);
                runInAction(() => {
                    if (onSuccess) { onSuccess() };
                    this.reset();
                    toast.success(`${i18n.t("wasUpdated", { entity: i18n.t("expenseVat") })}`);
                });
            } catch (error) {}
        } else {
            try {
                const data = await ExpenseVatServices.create(entity);
                runInAction(() => {
                    if (onSuccess) { onSuccess() };
                    toast.success(`${i18n.t("wasCreated", { entity: i18n.t("expenseVat") })}`);
                    this.reset();                    
                });
            } catch (error) {}
        }
    };

    reset = () => {        
        runInAction(() => this.expenseVat = {});
    }
   
    setConfig = (prop, c) => {        
        this.config[prop] = c;
    }

    getAllWithOptions = async (options/*page, filter, sort*/) => {
        try {
            const data = await ExpenseVatServices.getAllWithOptions(options/*{ page: page, filter: filter, sort: sort }*/);
            runInAction(() => {
                this.expenseVats = data;
            })
        }
        catch (error) {
            runInAction(() => {
                this.expenseVats = [];
            });
        }
    }

   /* getAll = async (page, filter, sort) => {
        try {            
            const data = await CurrencyServices.getAll({ page: page, filter: filter, sort: sort });
            runInAction(() => {this.currencies = data;})
        }
        catch (error) {
            runInAction(() => {this.currencies = [];});
        }
    }    */

    getById = async (id) => {
        try {
            const data = await ExpenseVatServices.getById(id);
            runInAction(() => { this.expenseVat = data;});
        } catch (error) {
            runInAction(() => { this.expenseVat = {};})
        }
    };
}